import clsx from 'clsx'

import {
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@ui/components/shadcn/ui'

interface Props {
  className?: string
  buttonClassName?: string
  title?: string
}

export const AdvertiserDisclosure = ({
  className,
  buttonClassName,
  title,
}: Props) => (
  <Popover>
    <PopoverTrigger asChild>
      <Button
        variant="link"
        size="sm"
        className={clsx(className, buttonClassName)}
      >
        {title || 'Advertiser Disclosure'}
      </Button>
    </PopoverTrigger>
    <PopoverContent>
      <p className="text-sm">
        The offers that appear are from companies which ATM.com and its partners
        receive compensation. This compensation may influence the selection,
        appearance, and order of appearance of the offers listed below. However,
        this compensation also facilitates the provision by ATM.com of certain
        services to you at no charge. The offers shown below do not include all
        companies or all of their available product and service offerings.
      </p>
    </PopoverContent>
  </Popover>
)

export const AffiliateDisclosure = ({ className }: Props) => (
  <p
    className={clsx(
      'content-disclosure bg-dolphin-100 rounded-lg p-4',
      className,
    )}
  >
    We may receive compensation from the products and services featured on this
    site. This may influence the placement of offers, but our opinions remain
    our own. Not all available products or offers are included.
  </p>
)

export const InstantCashDisclosure = ({ className }: Props) => (
  <p className={clsx('content-disclosure text-dolphin-900', className)}>
    *Eligibility is based on review and approval. Not all applicants will be
    eligible for ATM Instant Cash™.{' '}
    <span className="whitespace-pre">Transfer fees may apply.</span>
  </p>
)
